import { useEffect } from "react";

const ID_PREFIX = "kos-jsonld-";

/** Injects a JSON-LD <script> tag and tears it down on unmount.
 *  Pass either a single object or an array of objects (each becomes its own <script>). */
export const useJsonLd = (data, id) => {
  useEffect(() => {
    if (!data) return undefined;
    const list = Array.isArray(data) ? data : [data];
    const elements = list.map((obj, i) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = `${ID_PREFIX}${id}-${i}`;
      el.text = JSON.stringify(obj);
      document.head.appendChild(el);
      return el;
    });
    return () => {
      elements.forEach((el) => el.parentNode && el.parentNode.removeChild(el));
    };
  }, [data, id]);
};
